// Phase 2D.1B / 2D.2B follow-up — React wiring around lib/landing.js.
//
// Combines the two data sources the decision needs, both already trusted
// elsewhere in the app: AuthContext's session/organization state, and the
// backend-authoritative usePlatformAccess() check that PlatformAccessGate
// itself uses. No new authorization logic is introduced here.
import { useAuth } from "../contexts/AuthContext";
import { usePlatformAccess } from "./usePlatformAccess";
import { resolveAuthenticatedLanding } from "../lib/landing";

/** @returns {{ loading: boolean, path: string|null }} */
export function useAuthenticatedLanding() {
  const { loading: authLoading, session, orgs, orgsLoaded } = useAuth();
  const { loading: platformAccessLoading, isPlatformAdmin } = usePlatformAccess();

  if (authLoading) return { loading: true, path: null };

  const path = resolveAuthenticatedLanding({
    session,
    orgsLoaded,
    orgs,
    platformAccessLoading,
    isPlatformAdmin,
  });
  return { loading: path === null, path };
}

export default useAuthenticatedLanding;
